import { TariffSection } from '@/@types/generated/models/TariffSection'
import { register } from './enum'

const TariffSectionLabels: Record<TariffSection, string> = {
  [TariffSection.GENERAL]: 'General Rules',
  [TariffSection.ACCESSORIAL]: 'Accessorial Services',
  [TariffSection.RATES]: 'Rates',
  [TariffSection.MISCELLANEOUS]: 'Miscellaneous',
}

register<TariffSection>(TariffSection, (v) => {
  if (!v) return '—'
  return TariffSectionLabels[v]
})
